
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.56 25.56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.28 22.78a1 1 0 0 1-.71-.29l-9-9a1 1 0 0 1 0-1.42l9-9a1.004 1.004 0 1 1 1.42 1.42l-8.3 8.29 8.3 8.29a1 1 0 0 1 0 1.42 1 1 0 0 1-.71.29z"}})])
          )
        }
      }
    